"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBoxMask = void 0;
const React = require("react");
const TextBox_1 = require("./TextBox");
const react_native_1 = require("react-native");
const react_native_masked_text_1 = require("react-native-masked-text");
class TextBoxMask extends React.Component {
    render() {
        const _a = this.props, { type, options } = _a, textBoxProps = __rest(_a, ["type", "options"]);
        return (React.createElement(TextBox_1.TextBox, Object.assign({}, textBoxProps, { renderInput: props => {
                const { ref } = props, otherProps = __rest(props, ["ref"]);
                return react_native_1.Platform.OS === 'web' ? (
                // @ts-ignore :Waiting for typing https://github.com/benhurott/react-native-masked-text/pull/74
                React.createElement(react_native_masked_text_1.TextInputMask, Object.assign({}, otherProps, { type: type, options: options }))) : (
                // @ts-ignore :Waiting for typing https://github.com/benhurott/react-native-masked-text/pull/74
                React.createElement(react_native_masked_text_1.TextInputMask, Object.assign({}, otherProps, { 
                    // @ts-ignore : The component uses a different version of typing
                    refInput: ref, type: type, options: options })));
            } })));
    }
}
exports.TextBoxMask = TextBoxMask;
